// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___S2yP","option":"styles_option__2mDYz","active":"styles_active__3KUHC"};